import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib'; 
Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // default - only for display purposes
      },
    theme: {
      themes: {
        light: {
          primary: '#0099CC',
          secondary: '#0099CC', 
        },
        dark: {
          primary: '#FFFFFF',
          secondary: '#0099CC',
          primaryBlue: '#0099CC',
          },
      },
    },
  })

